<div class="session-expired" *ngIf="visible$ | async as visible; else nada">
  <div *ngIf="visible" class="session-expired__container">
    <div class="session-expired__msg">
      {{ (message$ | async) || 'Su sesión ha caducado.' }}
    </div>
    <div class="session-expired__actions">
      <button class="btn" (click)="onAccept()">Aceptar</button>
    </div>
  </div>
</div>
<ng-template #nada></ng-template>
